import React from 'react';
import { formatarQuantidade, formatarMoeda } from '../../utils/formatters';

const CardPostos = ({ dados, loading }) => {
  return (
    <div className="kpi-card">
      {/* Header */}
      <div className="kpi-card-header">
        <div className="flex items-center" style={{ gap: 'var(--space-fluid-xs)' }}>
          <div className="kpi-card-icon bg-purple-500">
            <svg className="text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: 'calc(var(--icon-fluid-md) * 0.5)', height: 'calc(var(--icon-fluid-md) * 0.5)' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h3 className="kpi-card-title">Postos</h3>
        </div>
      </div>

      {/* Valor Principal */}
      <div className="kpi-card-value">
        {loading ? (
          <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-lg)' }}></div>
        ) : (
          formatarQuantidade(dados.total)
        )}
      </div>

      {/* Informações secundárias */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-fluid-xs)' }}>
        {/* Média de lucro por posto */}
        <div>
          {loading ? (
            <div className="bg-gray-200 animate-pulse rounded w-3/4" style={{ height: 'var(--icon-fluid-sm)' }}></div>
          ) : (
            <div className="kpi-card-secondary">
              <span className="font-bold truncate">
                {formatarMoeda(dados.mediaLucroPorPosto || 0)}
              </span>
              <span className="kpi-card-secondary-label">média lucro/posto</span>
            </div>
          )}
        </div>

        {/* Ticket médio por posto */}
        <div>
          {loading ? (
            <div className="bg-gray-200 animate-pulse rounded w-3/4" style={{ height: 'var(--icon-fluid-sm)' }}></div>
          ) : (
            <div className="kpi-card-secondary">
              <span className="font-bold truncate">
                {formatarMoeda(dados.ticketMedioPorPosto || 0)}
              </span>
              <span className="kpi-card-secondary-label">ticket méd./posto</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardPostos;

